import React from "react";
import { Row, Col, Image } from "react-bootstrap";
import configuration from "react-global-configuration";

const NoPostFound = () => {
  return (
    <>
      <div className="no-data-found-sec">
        <Row>
          <Col sm="12" md="12">
            <div className="no-data-found-img-sec">
              {/* <Image
                alt="not-found"
                src={window.location.origin + "/assets/images/no-post-yet.png"}
                style={{ maxWidth: 550 }}
              /> */}
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default NoPostFound;
